// TODO: there is a lot of commented out code in the below file
// this is because birthday was removed, but might be re-added in the future
// if removing the birthday inputs is a permanent decision,
// then come back and delete the commented code at a later date

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import * as S from "./styles";
import { theme } from "@constants/theme";
import SVG from "@shared/atoms/SVG";
import svgs from "@shared/atoms/SVG/svgs";
import getSVGForCSS from "@util/getSVGForCSS";
// import DropdownButton from "@shared/atoms/DropdownButton";
// import { parse, isValid, format, isBefore } from "date-fns";
import { Track } from "@util/analytics";
import { useRouter } from "next/router";

const CreateAccountForm = ({
  className,
  onSubmit,
  serverErrors,
  loginLink,
}) => {
  const router = useRouter();
  // const [customDateErrors, setCustomDateErrors] = useState(null);
  const [passwordFieldType, setPasswordFieldType] = useState("password");

  // todo: hook up date fields to use react-hook-form
  // const [days, setDays] = useState([]);
  // const [months, setMonths] = useState([]);
  // const [years, setYears] = useState([]);
  // const [day, setDay] = useState(null);
  // const [month, setMonth] = useState(null);
  // const [year, setYear] = useState(null);

  const Checkmark = getSVGForCSS(svgs.Checkmark, theme.colors.grayscale.white);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  // useEffect(() => {
  //   setDefaultDaysArray();
  //   setDefaultMonthsArray();
  //   setDefaultYearsArray();
  // }, []);

  // const setDefaultDaysArray = () => {
  //   let day_start = 1;
  //   let day_end = 31;
  //   let daysArray = [];

  //   for (let i = day_start; i <= day_end; i++) {
  //     daysArray.push({ label: `${i}`, value: `${i}` });
  //   }

  //   setDays(daysArray);
  // };

  // const setDefaultMonthsArray = () => {
  //   setMonths([
  //     { label: "January", value: "1" },
  //     { label: "February", value: "2" },
  //     { label: "March", value: "3" },
  //     { label: "April", value: "4" },
  //     { label: "May", value: "5" },
  //     { label: "June", value: "6" },
  //     { label: "July", value: "7" },
  //     { label: "August", value: "8" },
  //     { label: "September", value: "9" },
  //     { label: "October", value: "10" },
  //     { label: "November", value: "11" },
  //     { label: "December", value: "12" },
  //   ]);
  // };

  // const setDefaultYearsArray = () => {
  //   let year_start = 1904; // oldest person in the world birth year
  //   let year_end = new Date().getFullYear() - 1; // current year
  //   let yearsArray = [];

  //   for (let i = year_end; i >= year_start; i--) {
  //     yearsArray.push({ label: `${i}`, value: `${i}` });
  //   }
  //   setYears(yearsArray);
  // };

  const handleShowPassword = () => {
    const newType = passwordFieldType === "password" ? "text" : "password";
    setPasswordFieldType(newType);
  };

  const handleOnSubmit = (data) => {
    // create account clicled
    Track("Create Account Clicked ");

    // const birthday = `${year}-${month}-${day}`;
    // if (!day || !month || !year) {
    //   setCustomDateErrors("birthday is required");
    // } else if (!validateDate(birthday)) {
    //   setCustomDateErrors("birthday must be valid date");
    // } else if (!validateMininumAge(birthday)) {
    //   setCustomDateErrors("must be older than 13");
    // } else {
    //   setCustomDateErrors(null);
    //   onSubmit({ ...data, date_of_birth: birthday });
    // }

    onSubmit({ ...data });
  };

  // const handleUpdateDay = (data) => {
  //   setDay(data.value.value);
  //   if (month && year) {
  //     setCustomDateErrors(null);
  //   }
  // };

  // const handleUpdateMonth = (data) => {
  //   setMonth(data.value.value);
  //   if (day && year) {
  //     setCustomDateErrors(null);
  //   }
  // };

  // const handleUpdateYear = (data) => {
  //   setYear(data.value.value);
  //   if (day && month) {
  //     setCustomDateErrors(null);
  //   }
  // };

  // const validateDate = (value) => {
  //   const parsed = parse(`${value}`, "yyyy-MM-dd", new Date());
  //   return isValid(parsed);
  // };

  // const validateMininumAge = (value) => {
  //   const parsed = parse(`${value}`, "yyyy-MM-dd", new Date());
  //   const today = new Date();
  //   const minYear = Number(format(today, "yyyy")) - 13;
  //   const minMonthAndDay = format(today, "MM-dd");
  //   const minDateString = `${minYear}-${minMonthAndDay}`;
  //   const minDate = parse(`${minDateString}`, "yyyy-MM-dd", new Date());
  //   return isBefore(parsed, minDate);
  // };

  const handleSignInLink = () => {
    Track("Sign In Clicked");
    router.push(loginLink);
  };

  const handleTermsLink = () => {
    Track("Terms Link Clicked");
  };

  return (
    <S.CreateAccountForm_div
      className={className}
      data-cy="create-account-form"
    >
      <S.MagicText_h1 type="h1">get started</S.MagicText_h1>
      <S.MagicText_p type="p1">
        Already a member?{" "}
        <S.Link_span onClick={handleSignInLink}>Sign in</S.Link_span>
      </S.MagicText_p>

      <S.Form_form onSubmit={handleSubmit(handleOnSubmit)} autocomplete="on">
        <S.MagicText_h5 type="h5">your name</S.MagicText_h5>
        <S.Input_input
          type="text"
          placeholder="first name"
          {...register("first_name", { required: "first name is required" })}
        />
        {errors.first_name && (
          <S.Error_span id="first_name_errors">
            {errors.first_name.message}
          </S.Error_span>
        )}

        {/* uncomment to re-enable birthday input */}
        {/* <S.MagicText_h5 type="h5">birthday</S.MagicText_h5>
        <S.DateContainer_div data-cy="date-container">
          <S.DateDropdownWrapper_div theme={theme}>
            <DropdownButton
              dropdownItems={months}
              onChange={handleUpdateMonth}
              thick={true}
              label="month"
            />
          </S.DateDropdownWrapper_div>
          <S.DateDropdownWrapper_div theme={theme}>
            <DropdownButton
              dropdownItems={days}
              onChange={handleUpdateDay}
              thick={true}
              label="day"
            />
          </S.DateDropdownWrapper_div>
          <S.DateDropdownWrapper_div theme={theme}>
            <DropdownButton
              dropdownItems={years}
              onChange={handleUpdateYear}
              thick={true}
              label="year"
            />
          </S.DateDropdownWrapper_div>
        </S.DateContainer_div>
        {customDateErrors ? (
          <S.Error_span id="date_errors">{customDateErrors}</S.Error_span>
        ) : null} */}

        <S.MagicText_h5 type="h5">account details</S.MagicText_h5>

        <S.Input_input
          type="email"
          placeholder="email"
          {...register("email", {
            required: "email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "email must be valid",
            },
          })}
        />
        {errors.email && (
          <S.Error_span id="email_errors">{errors.email.message}</S.Error_span>
        )}

        <S.PasswordFieldsContainer_div>
          <S.PasswordInput_input
            type={passwordFieldType}
            placeholder="password"
            {...register("password", {
              required: "password is required",
              minLength: {
                value: 8,
                message: "password must be at least 8 characters",
              },
            })}
          />
          <S.PasswordIcon_span onClick={handleShowPassword}>
            <SVG
              name={`${passwordFieldType === "password" ? "Show" : "Hide"}`}
              color={theme.colors.grayscale.ash}
            />
          </S.PasswordIcon_span>
        </S.PasswordFieldsContainer_div>
        {errors.password && (
          <S.Error_span id="password_errors">
            {errors.password.message}
          </S.Error_span>
        )}

        <S.PasswordFieldsContainer_div>
          <S.PasswordInput_input
            type={passwordFieldType}
            placeholder="confirm password"
            {...register("password_confirmation", {
              required: "password confirmation is required",
              validate: (val) => {
                if (watch("password") != val) {
                  return "password confirmation must match";
                }
              },
            })}
          />
          <S.PasswordIcon_span onClick={handleShowPassword}>
            <SVG
              name={`${passwordFieldType === "password" ? "Show" : "Hide"}`}
              color={theme.colors.grayscale.ash}
            />
          </S.PasswordIcon_span>
        </S.PasswordFieldsContainer_div>
        {errors.password_confirmation && (
          <S.Error_span id="password_confirmation_errors">
            {errors.password_confirmation.message}
          </S.Error_span>
        )}

        <S.CheckboxContainer_div>
          <S.CheckboxInput_input
            type="checkbox"
            {...register("accepted_terms", {
              required: "must accept terms of use",
            })}
            svg={Checkmark}
          />
          <S.CheckboxLabel_label htmlFor="accepted_terms">
            I confirm that I am at least 13 years old and agree to the{" "}
            <S.Link_a
              href="https://app.termly.io/document/terms-of-use-for-ecommerce/6c0c7f1b-0318-4ba5-afb4-193ae38053b2"
              target="_blank"
              onClick={handleTermsLink}
            >
              terms of use
            </S.Link_a>
          </S.CheckboxLabel_label>
        </S.CheckboxContainer_div>
        {errors.accepted_terms && (
          <S.Error_span id="accepted_terms_errors">
            {errors.accepted_terms.message}
          </S.Error_span>
        )}

        {serverErrors && (
          <S.Error_span id="serverErrors_errors">{serverErrors}</S.Error_span>
        )}

        <S.BrandButton_input
          text="create account"
          type="submit"
          onClick={handleSubmit(handleOnSubmit)}
        />
      </S.Form_form>
    </S.CreateAccountForm_div>
  );
};

CreateAccountForm.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  serverErrors: PropTypes.string,
  loginLink: PropTypes.string.isRequired,
};

export default CreateAccountForm;
